// frontend/src/components/grid/statusDerivers.js
//
// AG Grid valueGetter helpers — derive a status string from a row's
// underlying fields. Pair with the corresponding *StatusChip from
// StatusChipCells.jsx as cellRenderer. Extracted so StatusChipCells.jsx
// only exports React components (react-refresh/only-export-components —
// HMR boundary).

import { promotionEffectiveStatus } from '../../utils/promotionStatus';

/**
 * AG Grid adapter for `promotionEffectiveStatus`. Bind it with the store's
 * today so the column sorts and filters on the derived value:
 *
 *   valueGetter: (params) => derivePromotionStatus(params, storeToday)
 *
 * `today` is required rather than read from a clock here — the rule and the
 * reasoning live in utils/promotionStatus.js; this is only the grid seam.
 */
export function derivePromotionStatus(params, today) {
  return promotionEffectiveStatus(params.data, today);
}
